export default "__VITE_ASSET__62f0f7df__"